import { Component, OnInit } from '@angular/core';
import { SidebarComponent } from 'web-common/src/app/sidebar/sidebar.component';
import { NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'app-admin-sidebar',
    templateUrl: './admin-sidebar.component.html',
    styleUrls: ['../../../node_modules/web-common/src/app/sidebar/sidebar.component.less', '../../styles/admin-sidebar.component.less'],
    standalone: false
})
export class AdminSidebarComponent extends SidebarComponent implements OnInit {
  showSubmenu = false;
  private analyticsManuallyCollapsed = false;

  constructor(
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    this.syncSubmenuWithRoute();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.syncSubmenuWithRoute();
      }
    });
  }

  toggleAnalyticsSubmenu() {
    if (this.showSubmenu) {
      this.analyticsManuallyCollapsed = true;
      this.showSubmenu = false;
      return;
    }

    this.analyticsManuallyCollapsed = false;
    this.showSubmenu = true;
    this.router.navigate(['/analytics']);
  }

  private syncSubmenuWithRoute() {
    const analyticsRoute = this.isAnalyticsRoute(this.router.url);

    if (!analyticsRoute) {
      this.analyticsManuallyCollapsed = false;
      this.showSubmenu = false;
      return;
    }

    this.showSubmenu = !this.analyticsManuallyCollapsed;
  }

  private isAnalyticsRoute(url: string): boolean {
    return url === '/analytics' || url.indexOf('/analytics/') === 0;
  }

}
